$exso_sheets_app $mol_book2_catalog
	favicon $exso_logo_favicon
	title @ \Exso
	plugins / <= Theme $mol_theme_auto
	attr *
		^
		exso_sheets_app <= type \month
	ignored_spreads /
		\
		\site
		\device
	Menu null
	menu_foot /
		<= Lang $mol_locale_select dictionary *
			ru \Русский
			kk \Қазақша
		<= Lights $mol_lights_toggle
	Placeholder null
	user? null
	Login $exso_sheets_login
		login? <=> login? null
	spreads *
		site <= Site $exso_sheets_site 
			title_content <= title_content /
				<= Back $mol_button_minor
					click <= back_click null
					sub / <= Back_icon $mol_icon_arrow_left
				<= page_title*auto @ \Сводка за {}
			all_shifts <= shifts*auto
			all_blowings <= blowings*auto
			site_arg* *
			tools <= tools /
				<= Update $mol_button_minor
					click <= update null
					sub / <= Update_icon $mol_icon_reload
				<= Month $mol_button_minor
					click <= type_click*month null
					title @ \За месяц
				<= Day $mol_button_minor
					click <= type_click*day null
					title @ \За сутки
				<= Date $mol_date
					value? <=> date? <= default_date \
					value_moment => date_moment
					trigger_content / <= date_format \
					Clear null
			foot <= menu_foot
			device_arg* <= device_arg* *
				^ arg*device
				device <= id* \
		device <= Device $exso_sheets_device
			foot <= menu_foot
			tools / <= Date
			title_content /
				<= Back
				^
			all_shifts <= shifts*month /$exso_sheets_shift
		\
			<= Dashboard $exso_sheets_dashboard
				foot <= menu_foot
				tools <= tools
				title <= dashboard_title @ \Сводка за {1} и {2}
				shifts <= dashboard_shifts*auto <= shifts*auto /$exso_sheets_shift
				slice_shifts <= slice_shifts <= shifts*month
				plans <= plans /$exso_sheets_plan
				month_shifts <= dashboard_shifts*month
				blowings <= blowings*auto /$exso_sheets_blowing
				date_moment <= date_moment
				site_arg* <= site_arg* *
					^ arg*site
					site <= id* \
					type null
